import IntegrationStepItem, { type IntegrationStepView } from './IntegrationStepItem';
import type { IntegrationRunState } from '../../../hooks/useIntegrationRun';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import SmokeTestProgress from './SmokeTestProgress';
import { GlobalButton } from '@/components';
import DetailCard from '../DetailCard';
import {
  IntegrationRequestStatus,
  type IntegrationRequestDetail,
} from '../../../../../models/IntegrationRequest';
import {
  INTEGRATION_STEP_LABELS,
  INTEGRATION_STEPS_BY_TYPE,
  type IntegrationRequestStep,
  type IntegrationRequestStepId,
} from '../../../../../models/IntegrationRun';

const SIMULABLE_STATUSES = [IntegrationRequestStatus.PENDING, IntegrationRequestStatus.IN_PROGRESS];

const stepViews = (
  order: IntegrationRequestStepId[],
  steps: IntegrationRequestStep[],
  isRunning: boolean
) => {
  const firstPending = order.find((id) => !steps.some((step) => step.id === id));
  return order.map((id) => {
    const step = steps.find((item) => item.id === id);
    const view: IntegrationStepView = step
      ? step.state
      : isRunning && id === firstPending
        ? 'running'
        : 'pending';
    return { id, step, view };
  });
};

interface IntegrationRunProps {
  request: IntegrationRequestDetail;
  run: IntegrationRunState;
}

const IntegrationRun = ({ request, run }: IntegrationRunProps) => {
  const steps = run.simulation ?? request.steps ?? [];

  return (
    <DetailCard
      title={request.type === 'API' ? 'Integración' : 'Aplicación del webhook'}
      action={
        SIMULABLE_STATUSES.includes(request.status) && (
          <GlobalButton
            variant={GlobalButtonVariant.secondaryButton}
            action={run.simulate}
            disabled={run.isRunning}
          >
            Simular sin escribir
          </GlobalButton>
        )
      }
    >
      {run.simulation && (
        <p className='text-sm text-blue-800'>
          Simulación: así quedaría al integrar. No se escribió nada.
        </p>
      )}
      <ol>
        {stepViews(INTEGRATION_STEPS_BY_TYPE[request.type], steps, run.isRunning).map(({ id, step, view }) => (
          <IntegrationStepItem
            key={id}
            label={INTEGRATION_STEP_LABELS[id]}
            view={view}
            step={step}
          />
        ))}
      </ol>
      {run.isRunning && run.smokeResults.length > 0 && (
        <SmokeTestProgress results={run.smokeResults} />
      )}
    </DetailCard>
  );
};

export default IntegrationRun;
